// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.
export function createDashboardWebSocketController(options) {
    let ws;
    let reconnectTimer;
    let manualDisconnect = false;
    const isConnected = () => !!ws && ws.readyState === WebSocket.OPEN;
    const getSocket = () => ws;
    const scheduleReconnect = () => {
        if (reconnectTimer)
            return;
        reconnectTimer = setTimeout(() => {
            reconnectTimer = undefined;
            if (!manualDisconnect)
                connect();
        }, 4000);
    };
    function connect() {
        if (ws && ws.readyState === WebSocket.OPEN)
            return;
        if (reconnectTimer) {
            clearTimeout(reconnectTimer);
            reconnectTimer = undefined;
        }
        manualDisconnect = false;
        const url = options.getUrl();
        if (!url)
            return;
        options.onConnecting(url);
        options.onLog('Attempting connection to ' + url);
        try {
            ws = new WebSocket(url);
        }
        catch (error) {
            options.onLog('WebSocket creation failed: ' + String(error));
            scheduleReconnect();
            return;
        }
        options.onConnectedStateChange(false);
        ws.addEventListener('open', () => {
            options.onLog('Connected');
            options.onConnectedStateChange(true);
            options.onOpen();
        });
        ws.addEventListener('close', () => {
            options.onLog('Disconnected');
            options.onConnectedStateChange(false);
            ws = undefined;
            options.onClose();
            if (!manualDisconnect)
                scheduleReconnect();
        });
        ws.addEventListener('error', (event) => {
            options.onError(event);
        });
        ws.addEventListener('message', (ev) => {
            try {
                options.onParsedMessage(JSON.parse(ev.data));
            }
            catch (error) {
                options.onParseError(error);
            }
        });
    }
    const disconnect = () => {
        manualDisconnect = true;
        if (reconnectTimer) {
            clearTimeout(reconnectTimer);
            reconnectTimer = undefined;
        }
        if (ws) {
            try {
                ws.close();
            }
            catch (_a) {
                // ignore close failures
            }
            ws = undefined;
        }
    };
    const sendCommand = (command) => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            ws.send(JSON.stringify(command));
        }
    };
    return {
        connect,
        disconnect,
        sendCommand,
        isConnected,
        getSocket
    };
}
//# sourceMappingURL=dashboardWebSocket.js.map